// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { getDefaultSlots } from '@progress/kendo-vue-common';
/**
 * Represents the default `pickerWrap` component
 */

var PickerWrap = {
  props: {
    id: String
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    return h("span", {
      id: this.$props.id,
      attrs: this.v3 ? undefined : {
        id: this.$props.id
      },
      "class": 'k-picker-wrap'
    }, [defaultSlot]);
  }
};
export { PickerWrap };


//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-dateinputs/dist/es/common/PickerWrap.js
// module id = 364
// module chunks = 93